export default class ColorSelector {
  constructor($element, options = {}) {
    this.$element = $element;

    this.options = {
      classes: {
        filter: 'color-selector__colors-filter',
        buttonActive: 'button--active',
        resultsNumberValue: 'color-selector__colors-results-number-value',
        filterButton: 'color-selector__colors-filter-button',
        item: 'color-selector__colors-grid-item',
        itemVisible: 'color-selector__colors-grid-item--visible',
        itemInvisible: 'color-selector__colors-grid-item--invisible',
      },
      ...options,
    };

    this.$resultNumberValue = this.$element.querySelector(`.${this.options.classes.resultsNumberValue}`);
    this.$resetButton = this.$element.querySelector(`.${this.options.classes.filterButton}[data-filter="all"]`);
    this.$filterButtons = this.$element.querySelectorAll(`.${this.options.classes.filterButton}[data-filter]:not([data-filter="all"])`);
    this.$filterItems = this.$element.querySelectorAll(`.${this.options.classes.item}`);

    this.init();
  }

  init() {
    // handle click on "All" (resetbutton)
    this.$resetButton.addEventListener('click', (e) => {
      const buttonClasses = e.currentTarget.classList;

      if (!buttonClasses.contains(`${this.options.classes.buttonActive}`)) {
        e.currentTarget.classList.add(`${this.options.classes.buttonActive}`);

        this.$filterButtons.forEach(($filterButton) => {
          $filterButton.classList.remove(`${this.options.classes.buttonActive}`);
        });
      }

      this.resetFilterItems();
    });

    // handle click on all filters but "All"
    this.$filterButtons.forEach(($filterButton) => {
      $filterButton.addEventListener('click', (e) => {
        const buttonClasses = e.currentTarget.classList;

        if (buttonClasses.contains(`${this.options.classes.buttonActive}`)) {
          e.currentTarget.classList.remove(`${this.options.classes.buttonActive}`);
          e.currentTarget.blur();
        } else {
          e.currentTarget.classList.add(`${this.options.classes.buttonActive}`);
        }

        if (this.getNoActiveFilters() > 0) {
          this.$resetButton.classList.remove(`${this.options.classes.buttonActive}`);
        } else {
          this.$resetButton.classList.add(`${this.options.classes.buttonActive}`);
        }

        this.filterItems();
      });
    });
  }

  getNoActiveFilters() {
    let noActiveFilters = 0;
    this.$filterButtons.forEach(($filterButton) => {
      if ($filterButton.classList.contains('button--active')) {
        noActiveFilters += 1;
      }
    });
    return noActiveFilters;
  }

  getActiveFilters() {
    const activeFilters = [];
    this.$filterButtons.forEach(($filterButton) => {
      if ($filterButton.classList.contains('button--active')) {
        activeFilters.push($filterButton.dataset.filter);
      }
    });

    return activeFilters;
  }

  setItemNumberValue() {
    this.$resultNumberValue.innerHTML = this.$element.querySelectorAll(`.${this.options.classes.itemVisible}`).length;
  }

  filterItems() {
    const activeFilters = this.getActiveFilters();

    if (activeFilters.length > 0) {
      this.$filterItems.forEach(($filterItem) => {
        const itemFilters = JSON.parse($filterItem.dataset.filterProps).map(
          element => element.toLowerCase(),
        );

        const hasFilter = itemFilters.filter(obj => activeFilters.indexOf(obj) !== -1);

        if (hasFilter.length > 0) {
          $filterItem.classList.add(`${this.options.classes.itemVisible}`);
          $filterItem.classList.remove(`${this.options.classes.itemInvisible}`);
        } else {
          $filterItem.classList.remove(`${this.options.classes.itemVisible}`);
          $filterItem.classList.add(`${this.options.classes.itemInvisible}`);
        }
      });
    } else {
      this.resetFilterItems();
    }

    this.setItemNumberValue();
  }

  resetFilterItems() {
    this.$filterItems.forEach(($filterItem) => {
      $filterItem.classList.add(`${this.options.classes.itemVisible}`);
      $filterItem.classList.remove(`${this.options.classes.itemInvisible}`);
    });

    this.setItemNumberValue();
  }
}

// Select the entire DOM for observing:
const target = document.querySelector('body');

// Create a new observer instance:
const observer = new MutationObserver((() => {
  if (document.querySelector('.js-color-selector')) {
    document.querySelectorAll('.js-color-selector').forEach(
      $colorSelector => new ColorSelector($colorSelector),
    );
  }
}));

// Set configuration object:
const config = { childList: true };

// Start the observer
observer.observe(target, config);
